<template>
  <figure :class="wrapperClasses">
    <img v-if="hasPreview" :src="preview" class="preview" />
    <div class="video-overlay" v-on:click="load">
      <b-icon icon="play" />
    </div>
    <iframe v-if="playMode" :src="src" :width="width" :height="height"></iframe>
    <figcaption>
      <p class="caption">{{caption}}</p>
    </figcaption>
  </figure>
</template>
<script type="text/javascript">
import filters from "../mixins/filters";
import { extractString } from "../api/helpers";

export default {
  name: "EmbeddedVideo",
  props: {
    item: {
      type: Object,
      required: true,
      default: null
    },
    auto: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  mixins: [filters],
  data() {
    return {
      playMode: false
    };
  },
  mounted() {
    if (this.auto) {
      this.playMode = true;
    }
  },
  watch: {
    active(boolVal) {
      if (this.auto === true && boolVal === false) {
        this.playMode = false;
      } else {
        this.load();
      }
    }
  },
  computed: {
    preview() {
      return extractString(this.item, "preview");
    },
    src() {
      let src = extractString(this.item, "src");
      if (this.item.mime.indexOf("vimeo") >= 0) {
        src += "?byline=0&title=0&share=0&fun=0&portrait=0&sidedock=0&dnt=0";
      }
      return src;
    },
    hasPreview() {
      return this.preview.length > 2;
    },
    width() {
      return extractString(this.item, "width");
    },
    height() {
      return extractString(this.item, "height");
    },
    caption() {
      return extractString(this.item, "title");
    },
    wrapperClasses() {
      const { width, height } = this.item;
      const ratio = width / height;
      const aspect = ratio < 1 ? "portrait" : "landscape";
      let cls = ["embedded-video", aspect];
      const isInRange = (val, targetRatio, tolerance) =>
        val < targetRatio * (1 + tolerance) &&
        val > targetRatio * (1 - tolerance);
      if (isInRange(ratio, 16 / 9, 0.01)) {
        cls.push("ratio-16-9");
      } else if (isInRange(ratio, 2 / 1, 0.01)) {
        cls.push("ratio-2-1");
      } else if (isInRange(ratio, 4 / 3, 0.01)) {
        cls.push("ratio-4-3");
      }
      if (this.playMode) {
        cls.push("playing");
      }
      return cls;
    }
  },
  methods: {
    load() {
      if (this.src.length > 3) {
        this.playMode = true;
      }
    },
    unload() {
      this.playMode = false;
    }
  }
};
</script>
